import {
  type ArithmeticWorksheetPrintRequest,
  type CasReportPrintRequest,
  type OneClickReportPrintRequest,
  type RealTimeReportPrintRequest,
  remotePrintApi,
  type RemotePrintOption,
  type ReportPrintRequest,
  type SchoolTestPrintRequest,
  type WorkbookPrintRequest,
  type WorksheetPrintRequest,
} from '@mathflat/domain/RemotePrint'

import { mpEventInfo } from '@/constant'
import type { WorksheetExportType } from '@/contentComponents/modal/Download/type'

import type Controller from './Controller'

class PrintController implements Controller {
  adapter = {
    from(data) {
      return data
    },
  }

  async fetchPrintAgentList(teacherId: RemotePrintOption['teacherId']) {
    return remotePrintApi.getPrintAgents(teacherId, { mp_event_name: mpEventInfo.PC버전등록_인쇄 })
  }

  async postMQTTPrintWorksheet(data: WorksheetPrintRequest, type?: WorksheetExportType) {
    // 연산 학습지 인쇄는 postMQTTPrintCalculation 이 따로 트래킹한다
    return remotePrintApi.printWorksheet(
      data,
      type !== 'ARITHMETIC' ? { mp_event_name: mpEventInfo['학습지_인쇄(비동기)'] } : undefined,
    )
  }

  async postMQTTPrintCustomWorkbook(data: WorkbookPrintRequest) {
    return remotePrintApi.printCustomWorkbook(data, {
      mp_event_name: mpEventInfo['학원교재_인쇄(비동기)'],
    })
  }

  async postMQTTPrintReport(data: ReportPrintRequest) {
    return remotePrintApi.printReport(data, { mp_event_name: mpEventInfo.보고서_인쇄 })
  }

  async postPrintOneClickReport(data: OneClickReportPrintRequest) {
    return remotePrintApi.printOneClickReport(data, {
      mp_event_name: mpEventInfo['원클릭보고서_인쇄(비동기)'],
    })
  }

  async postPrintMQTTReportCas(data: CasReportPrintRequest) {
    return remotePrintApi.printCasReport(data, {
      mp_event_name: mpEventInfo['원클릭보고서_인쇄(비동기)'],
    })
  }

  async postMQTTPrintCalculation(data: ArithmeticWorksheetPrintRequest) {
    return remotePrintApi.printWorksheet(data, { mp_event_name: mpEventInfo['연산_인쇄(비동기)'] })
  }

  async postPrintWorkbookQuick(data: WorkbookPrintRequest) {
    return remotePrintApi.printCustomWorkbookQuickAnswer(data, {
      mp_event_name: mpEventInfo.교재빠른정답,
    })
  }

  async postMQTTPrintReportRealTime(data: RealTimeReportPrintRequest) {
    return remotePrintApi.printRealTimeReport(data)
  }

  async postMQTTPrintSchoolTest(data: SchoolTestPrintRequest) {
    return remotePrintApi.printSchoolTests(data)
  }
}

export const printController = new PrintController()
